import React from 'react';
import Link, { push } from 'gatsby-link';

import styles from '../assets/css/button.module.css';

class Footer extends React.Component {

    constructor(props) {
        super(props);
    }

    saveAndProceed = () => {
        
        let url;

        if (this.props.about === 'me') {
            url = '/about-me/';
        } else {
            url = '/about-court/';
        }

        if (this.props.about === 'me' && this.props.proceedLink === 'finished' || this.props.about === 'court' && this.props.proceedLink === 'finished') {
            url = '/finished'
        }

        if(this.props.query) {

            if (this.props.proceedLink === 'finished') {

                push(url);

            } else {
                push(url + this.props.proceedLink);
            }

        }
        
    }

    _renderBack = () => {

        let backLink = '/';

        if (this.props.about === 'me') {
            backLink = '/about-me/' + this.props.backLink
        } else {
            backLink = '/about-court/' + this.props.backLink
        }

        if (this.props.about === 'me' && this.props.backLink === '/' || this.props.about === 'court' && this.props.backLink === '/') {
            backLink = '/please-select'
        }

        let text = this.props.currentPage != 1 ? 'Back' : 'Quit';

        return (

            <Link to={backLink} className={styles.back + ' no-underline text-gray ][ flex items-center justify-center  ][ p-8 ]'}>
                <span className="block">{text}</span>
            </Link>

        )
    }

    _renderProceed = () => {

        let canProceedStyle = this.props.query ? 'opacity-100' : 'opacity-50';
        let text = this.props.about === 'me' && this.props.currentPage == 15 || this.props.about === 'court' && this.props.currentPage == 8 ? 'Finished' : 'Next';

        return (

            <button type="button" onClick={this.saveAndProceed} className={styles.proceed + ' no-underline text-white [ focus:outline-none ][ flex items-center justify-center ]' + '[ ' + canProceedStyle + ' ]'}>
                <span className="block">{text}</span>
            </button>

        );
    }

    render() {

        return (

            <footer className="fixed pin-l pin-b pin-r z-10 [ bg-white ][ flex items-center justify-between text-3xl leading-tight py-8 ]">

                {this._renderBack()}

                <p className="text-gray font-heading">{this.props.currentPage}/{this.props.about === 'me' ? '15' : '9'}</p>

                {this._renderProceed()}

            </footer>

        )
    }

}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js